export const CREATE_SUBFEEDBACK = 'create_subfeedback'
export const UPDATE_SUBFEEDBACK = 'update_subfeedback'
export const GET_SUBFEEDBACK = 'get_subfeedback'
export const ATTACH_SUBFEEDBACK_IMAGE = 'attach_subfeedback_image'

export const GET_FEEDBACKS = 'get_feedbacks'
export const GET_FEEDBACK = 'get_feedback'
export const GET_FEEDBACK_MANAGERS = 'get_feedback_managers'
export const GET_FEEDBACK_ORDERS = 'get_feedback_orders'
export const UPDATE_FEEDBACK = 'update_feedback'
export const CREATE_FEEDBACK = 'create_feedback'

export const CREATE_ITEM_REVIEW = 'create_item_review'

export const GET_ORDER_BY_HASH = 'get_order_by_hash'

export const CREATE_REVIEW = 'create_review'

export const CREATE_SUBREVIEW = 'create_subreview'

export const GET_FEEDBACK_STATUSES = 'get_feedback_statuses'

export const GET_CUSTOMERS = 'get_customers'

export const UPLOAD_IMAGE = 'upload_image'

export const GET_BOOKING_SOURCES = 'get_booking_sources'
